<script>
    export default {
        name: "RecipeDetailLoading",
    };
</script>

<template>
    <div class="recipe-detail-loading recipe-detail__section">
        <div
            class="recipe-detail-loading__title recipe-detail-loading__skeleton desktop-hidden"
        ></div>
        <div class="recipe-detail-loading__inner">
            <div class="recipe-detail-loading__images"></div>
            <div class="recipe-detail-loading__info">
                <div
                    class="recipe-detail-loading__title recipe-detail-loading__skeleton mobile-hidden"
                ></div>

                <div class="recipe-detail-loading__specs">
                    <div
                        class="recipe-detail-loading__spec recipe-detail-loading__skeleton"
                    ></div>
                    <div
                        class="recipe-detail-loading__spec recipe-detail-loading__skeleton"
                    ></div>
                </div>

                <div class="recipe-detail-loading__ingredients"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .recipe-detail-loading {
        padding: 24px 16px 16px;
        @include bp($bp-desktop-sm) {
            padding: 40px 40px 48px;
        }
    }

    .recipe-detail-loading__skeleton {
        background-color: var(--input-border-color);
        border-radius: 8px;
        @include bp($bp-desktop-sm) {
            border-radius: 10px;
        }
    }

    .recipe-detail-loading__title {
        margin-bottom: 16px;
        height: 22px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 12px;
            height: 40px;
        }
    }

    .recipe-detail-loading__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
        }
    }

    .recipe-detail-loading__images {
        position: relative;
        margin-bottom: 16px;
        border-radius: 15px;
        background-color: var(--input-border-color);
        &::before {
            content: "";
            display: block;
            padding-bottom: 66.66%;
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 690px;
            max-width: 690px;
            margin-right: 40px;
            margin-bottom: 0;
            border-radius: 25px;
        }
    }

    .recipe-detail-loading__info {
        width: 100%;
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-direction: column;
        }
    }

    .recipe-detail-loading__specs {
        display: flex;
        margin-bottom: 16px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
        }
    }

    .recipe-detail-loading__spec {
        display: flex;
        align-items: center;
        width: 80px;
        height: 24px;
        margin-right: 16px;
        @include bp($bp-desktop-sm) {
            margin-right: 24px;
        }
    }

    .recipe-detail-loading__ingredients {
        height: 80px;
        background-color: var(--input-border-color);
        border-radius: 10px;
        @include bp($bp-desktop-sm) {
            height: 120px;
        }
    }
</style>
